import { render, staticRenderFns } from "./Dialogs.vue?vue&type=template&id=68b494b4"
import script from "./Dialogs.vue?vue&type=script&lang=js"
export * from "./Dialogs.vue?vue&type=script&lang=js"
import style0 from "./Dialogs.vue?vue&type=style&index=0&id=68b494b4&prod&lang=scss&module=true"
import style1 from "./Dialogs.vue?vue&type=style&index=1&id=68b494b4&prod&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports